import { Component, OnInit, Inject, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {MatSnackBar as MatSnackBar } from '@angular/material/snack-bar';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { saveAs } from 'file-saver';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

export enum Symbols {
  boven = 'column-reverse',
  onder = 'column',
  links = 'row-reverse',
  rechts = 'row'
}
@Component({
  selector: 'app-view-file',
  templateUrl: './view-file.component.html',
  styleUrls: ['./view-file.component.css'],

})
export class ViewFileComponent implements OnInit {

  media: any = {};
  user: any;
  modalRef: BsModalRef | null;
  currentFolder: any = { folderPath: '' };
  event: any;
  showEditor: boolean = false
  showtext: boolean;
  constructor(private router: Router, private authService: AuthService, private snotifyService: ToastrService, private httpClient: HttpClient, private _snackBar: MatSnackBar, public dialogRef: MatDialogRef<ViewFileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private modalService: BsModalService) {
      
    }

  ngOnInit() {

    this.user = this.authService.getLoggedUser()
    this.media = this.data.File;
    this.currentFolder = this.data.folder;
  }



  getThumbnailUrl(url) {
    return window['config'].apiUrl + '/' + url;
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
    timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  copyAddress(val: string) {
    const copy = document.createElement('textarea');
    copy.value = window['config'].apiUrl + '/' + val;
    document.body.appendChild(copy);
    copy.focus();
    copy.select();
    document.execCommand('copy');
    document.body.removeChild(copy);
    this.openNotifySuccess("File location Copied")
  }

  download(file) {
    this.httpClient.get('/DCMS-backend/' + file.publicUrl, { responseType: 'arraybuffer' })
      .subscribe((response: any) => {
        let blob = new Blob([response], { type: file.contentType });
        saveAs(blob, file.fileName);
      });
  }

  openEditor(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg', backdrop: 'static' });
    this.showEditor = true;
  }

  getEditedFile(event) {
    this.modalRef.hide();
    this.event = event
    this.newFile()
  }
  // Replace() {
  //   this.removeMedia(this.media);
  //   var formData = new FormData();
  //   formData.append("path", this.currentFolder.folderPath);
  //   formData.append("file", this.event);
  //   this.httpClient.post('/Media/SaveMedia', formData).subscribe((res: any) => {
  //     this.GetFolderMediaAndFolders(this.currentFolder.folderPath)
  //   });

  // }

  // cancelEdit(template) {
  //   this.modalRef = this.modalService.show(template, { class: 'modal-lg', backdrop: 'static' });
  // }

  newFile() {
    var name = this.event.name
    var newfile = name.substring(0, name.lastIndexOf(".")) + "-edit" + name.substring(name.lastIndexOf("."));
    var blob = this.event.slice(0, this.event.size);
    var newFile = new File([blob], newfile);
    var formData = new FormData();
    formData.append("path", this.currentFolder.folderPath);
    formData.append("file", newFile);
    this.httpClient.post('/Media/SaveMedia', formData).subscribe((res: any) => {
      this.dialogRef.close('refresh');
    });
  }

  rename(event) {

    this.media.newname = this.media.fileName
    var newfile = this.media.newname.substring(0, this.media.newname.lastIndexOf(".")) + this.media.newname.substring(this.media.newname.lastIndexOf("."));
    // var blob = new Blob([this.media.size], {
    //   type: this.media.contentType,

    // });
    //
    this.httpClient.get('/DCMS-backend/' + this.media.publicUrl, { responseType: 'arraybuffer' })
      .subscribe((response: any) => {
        let blob = new Blob([response], { type: this.media.contentType });
        var formData = new FormData();
        var n = new File([blob], newfile);
        formData.append("path", this.currentFolder.folderPath);
        formData.append("file", n);

        this.httpClient.post('/Media/SaveMedia', formData).subscribe((res: any) => {
          this.dialogRef.close('refresh');
        });
        var data = { Path: this.media.publicUrl };
        this.httpClient.post('/Media/DeleteFile', data).subscribe((res: any) => {

          //   this.openNotifySuccess("File Deleted")
        });
      });








  }

  fabButtons = [
    {
      icon: 'settings',
      information: 'U heeft op het icoon "settings" geklikt',
      route: 'Settings',
      description: 'Settings'
    },
    {
      icon: 'lightbulb',
      information: 'U heeft op het icoon "lightbulb" geklikt',
      route: 'Ideas',
      description: 'Ideas'
    },
    {
      icon: 'lock',
      information: 'U heeft op het icoon "lock" geklikt',
      route: 'Login',
      description: 'Login'
    },
    {
      icon: 'home',
      information: 'U heeft op het icoon "home" geklikt',
      route: 'Home',
      description: 'Home'
    }
  ];

  fabButtons2 = [
    {
      icon: 'add',
      information: 'U heeft op het icoon "add" geklikt',
      route: '',
      description: 'Add'
    },
    {
      icon: 'refresh',
      information: 'U heeft op het icoon "refresh" geklikt',
      route: '',
      description: 'Refresh'
    }
  ];

  buttons = [];

  buttons2 = []

  fabTogglerState = 'inactive';

  showItems() {
    this.fabTogglerState = 'active';
    this.buttons = this.fabButtons;
  }

  hideItems() {
    this.fabTogglerState = 'inactive';
    this.buttons = [];
  }

  showItems2() {
    this.fabTogglerState = 'active';
    this.buttons2 = this.fabButtons2;
  }

  hideItems2() {
    this.fabTogglerState = 'inactive';
    this.buttons2 = [];
  }

  onToggleFab() {
    this.buttons.length ? this.hideItems() : this.showItems();
  }

  onToggleFab2() {
    this.buttons2.length ? this.hideItems2() : this.showItems2();
  }

  onClick(btn) {
    // console.log(btn.route)
    this.router.navigate([btn.route]);
    // this.onToggleFab();
  }

  keys = Object.keys;
  symbols = Symbols;
  selectedOption: string;

}
